var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6566 22.0667C35.9951 19.0098 35.4089 15.9216 33.9738 13.2013C32.5388 10.481 30.3209 8.25356 27.6067 6.80692C24.8925 5.36029 21.8069 4.76092 18.7485 5.08628C15.6902 5.41165 12.7997 6.64678 10.4506 8.63206C8.10153 10.6173 6.40187 13.2615 5.57127 16.2229C4.74068 19.1842 4.81732 22.3266 5.7913 25.2439C6.76529 28.1613 8.59183 30.7194 11.0349 32.5878C13.478 34.4562 16.4252 35.549 19.4958 35.7249M6.0239 15.2505H34.7239M6.0239 25.5005H29.7697",
    stroke: "url(#paint0_linear_1694_4585)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5209 5.00049C16.643 9.61233 15.1172 14.9393 15.1172 20.3755C15.1172 25.8116 16.643 31.1387 19.5209 35.7505M21.2293 5.00049C25.0412 11.1087 26.4481 18.4152 25.1772 25.5022M25.5001 32.3338L28.9168 35.7505L35.7501 28.9172",
    stroke: "url(#paint1_linear_1694_4585)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1694_4585",
    x1: 5,
    y1: 1.15939,
    x2: 37.7518,
    y2: 37.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1694_4585",
    x1: 15.1172,
    y1: 1.15674,
    x2: 46.5324,
    y2: 24.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer5);
export default __webpack_public_path__ + "static/media/Offer5.5f8bb927e3686d8aa16ad3f93b89a66c.svg";
export { ForwardRef as ReactComponent };